/**
 * Statistics Binning
 */
export enum StatisticsBinning {
  /**
   * Month.
   */
  Month = 'month',

  /**
   * Date of the month.
   */
  DateOfTheMonth = 'date-of-the-month',
}
